export const ADD_VIDEO_INIT_VALUES = {
  youtubeUrl: '',
};

export const DEFAULT_VIDEO = {
  defaultId: 'DEFAULT',
  youtubeId: 'f5f3yiUav9g',
};
